<template>
  <div class="invoice_success">
    <!--  正文  -->
    <div class="success">
      <img src="../../../assets/images/invoive/susses.png" alt="" class="success_img">
      <div class="success_title">提交成功</div>
    </div>
    <van-notice-bar
      class="notice_bar"
      left-icon="volume-o"
      text="您的发票预计将在24小时内开出，请注意查收。"
    />
    <div class="success-btn" @click="checkMyInvoice">查看我的开票</div>
  </div>
</template>

<script>
  import app from '@/api/app'
  export default {
    name: "invoiceSuccess",
    methods: {
      // 关闭
      checkMyInvoice() {
        this.$router.push({name: 'invoiceRecord', query: {communityId: localStorage.getItem('communityId'), token: localStorage.getItem('token'), chargeOrderId: localStorage.getItem('chargeOrderId')}})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .success {
    display: flex;
    justify-content: center;
    padding-top: 37px;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
    .success_img {
      width: 116px;
      margin-bottom: 9px;
    }
    .success_title {
      font-family: PingFang SC;
      font-weight: 500;
      color: #222;
      font-size: 20px;
    }
  }
  // 通知栏
  .notice_bar {
    margin-bottom: 32px;
    /deep/.van-notice-bar__content {
      font-size: 12px;
    }
  }
  // 按钮
  .success-btn {
    height: 48px;
    background: #FF8A49;
    opacity: 1;
    border-radius: 5px;
    line-height: 48px;
    color: #fff;
    font-size: 16px;
    font-family: PingFang SC;
    text-align: center;
  }
</style>
